import { z } from '@harvestiq/zod';
import {
  RmaLgmCommodityCode,
  RmaLgmCommodityCodes,
  RmaLrpCommodityCode,
  RmaLrpCommodityCodes,
} from '@harvestiq/constants';
import { GeneratedAlways, Selectable, Insertable, Updateable } from 'kysely';
import { DbTimestampGenerated, DbTimestampNullable } from '@harvestiq/utils';

export interface PolicyCoveragesTable {
  id: GeneratedAlways<string>;
  policyId: string;
  fipsCountyCode: string | null; // Five digit FIPS county code, see RMA ADM A00440
  commodityCode: RmaLrpCommodityCode | RmaLgmCommodityCode;
  mergedIntoPolicyCoverageId: string | null; // ID of the policy coverage this one was merged into, if any
  zipCode: string | null;
  createdAt: DbTimestampGenerated;
  updatedAt: DbTimestampGenerated;
  deletedAt: DbTimestampNullable;
}

export type DbPolicyCoverage = Selectable<PolicyCoveragesTable>;
export const dbPolicyCoverageSchema = z.object({
  id: z.string(),
  policyId: z.string(),
  fipsCountyCode: z.string().nullable(),
  commodityCode: z
    .nativeEnum(RmaLrpCommodityCodes)
    .or(z.nativeEnum(RmaLgmCommodityCodes)),
  mergedIntoPolicyCoverageId: z.string().nullable(),
  zipCode: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable(),
});

export type DbPolicyCoverageInsert = Insertable<PolicyCoveragesTable>;
export const dbPolicyCoverageInsertSchema = dbPolicyCoverageSchema.omit({
  id: true,
  createdAt: true,
});

export type DbPolicyCoverageUpdate = Updateable<PolicyCoveragesTable>;
export const dbPolicyCoverageUpdateSchema = dbPolicyCoverageSchema
  .omit({
    id: true,
    createdAt: true,
  })
  .partial();
